import { useInspirationJourney } from "web_myplann/Inspiration/Hooks/useInspirationJourney";
import { useOwnHomeContext } from "web_myplann/Inspiration/OwnHome/Hooks/useOwnHomeContext";
import type { OwnHomeInputs } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";

export type OwnHomeSheet = "quick" | "expenses" | "affordability-edit";

export const useOwnHomeJourney = () => {
	const journey = useInspirationJourney<OwnHomeInputs, OwnHomeSheet>({});

	const { context, isLoading } = useOwnHomeContext(journey.inputs);

	return { ...journey, context, isLoading };
};
